import * as React from 'react';

import { Grid, Typography } from '@mui/material';

type DetailRowProps = {
  label: string | React.ReactElement;
  description?: string | null | React.ReactElement;
  alignItems?: string;
};

const DetailRow: React.FC<DetailRowProps> = ({ label, description, alignItems = 'center' }) => (
  <Grid
    container
    sx={{
      display: 'flex',
      alignItems,
      py: '14px',
      borderBottom: '1px solid #F2F2F2',
      '&:last-of-type': { borderBottom: 'none' },
    }}
  >
    <Grid item xs={5}>
      <Typography
        sx={{ fontSize: '15px', color: '#848484', fontWeight: 400, fontFamily: 'Poppins' }}
      >
        {label}
      </Typography>
    </Grid>
    <Grid item xs={7}>
      <Typography
        component='div'
        sx={{ fontSize: '15px', color: '#111', fontWeight: 500, fontFamily: 'Poppins' }}
      >
        {description}
      </Typography>
    </Grid>
  </Grid>
);

export default DetailRow;
